import {
  GetDoctorsWorkByDepartId,
  GetRegistrationInfoByDepartId,
  GetModalityCountByDepartId,
  GetDoctorsWorkForPI,
  GetModalityCountForPI,
  GetSelfDepartPositiveRate
} from '@/api/statistic'

const statistic = {
  state: {
    doctorsWork: [],
    deviceWork: [],
    hospWork: [],
    watchObj: {},
    crdoctorsWork: [],
    apdoctorsWork: [],
    hospWorkpi: [],
    selfDeaprtPoaitiveRate: [],
    selfDeaprtPoaitiveRatePI: {}
  },
  mutations: {
    GET_DOCTORSWORK: (state, datas) => {
      state.doctorsWork = datas
    },
    GET_DEVICESWORK: (state, datas) => {
      state.deviceWork = datas
    },
    GET_HOSPWORK: (state, datas) => {
      state.hospWork = datas
    },
    GET_WATHCHOBJ: (state, datas) => {
      state.watchObj = datas
    },
    GET_CRDOCTORSWORKPI: (state, datas) => {
      state.crdoctorsWork = datas
    },
    GET_APDOCTORSWORKPI: (state, datas) => {
      state.apdoctorsWork = datas
    },
    GET_HOSPWORKPI: (state, datas) => {
      state.hospWorkpi = datas
    },
    GET_SELFDEPARTPOSITIVERATE: (state, datas) => {
      state.selfDeaprtPoaitiveRate = datas
    },
    GET_SELFDEPARTPOSITIVERATEPI: (state, datas) => {
      state.selfDeaprtPoaitiveRatePI = datas
    }
  },
  actions: {
    GetDoctorsWorkByDepartId({ commit }, data) {
      // 执行单列表
      return new Promise((resolve, reject) => {
        GetDoctorsWorkByDepartId(data)
          .then(response => {
            const data = response.data
            commit('GET_WATHCHOBJ', data)
            if (data.doctors.length > 0) {
              for (let i = 0; i < data.doctors.length; i++) {
                for (
                  let v = 0;
                  v < data.doctors[i].createModalitys.length;
                  v++
                ) {
                  data.doctors[i][
                    'C' + data.doctors[i].createModalitys[v].modalityName
                  ] = data.doctors[i].createModalitys[v].count
                }
                for (
                  let v = 0;
                  v < data.doctors[i].firstApproveModalitys.length;
                  v++
                ) {
                  data.doctors[i][
                    'A' + data.doctors[i].firstApproveModalitys[v].modalityName
                  ] = data.doctors[i].firstApproveModalitys[v].count
                }
              }
              commit('GET_DOCTORSWORK', data.doctors)
            } else {
              commit('GET_DOCTORSWORK', [])
            }
            resolve()
          })
          .catch(error => {
            commit('GET_DOCTORSWORK', [])
            commit('GET_WATHCHOBJ', {})
            reject(error)
          })
      })
    },
    GetRegistrationInfoByDepartId({ commit }, data) {
      // 执行单列表
      return new Promise((resolve, reject) => {
        GetRegistrationInfoByDepartId(data)
          .then(response => {
            const data = response.data
            console.log(data)
            // if (data.doctors.length > 0) {
            //   commit('GET_DOCTORSWORK', data.doctors)
            // } else {
            //   commit('GET_DOCTORSWORK', [])
            // }
            resolve()
          })
          .catch(error => {
            // commit('GET_DOCTORSWORK', [])
            reject(error)
          })
      })
    },
    GetDoctorsWorkForPI({ commit }, data) {
      // 执行单列表
      return new Promise((resolve, reject) => {
        GetDoctorsWorkForPI(data)
          .then(response => {
            const data = response.data
            commit('GET_WATHCHOBJ', data)
            if (data.createDoctors.length > 0) {
              commit('GET_CRDOCTORSWORKPI', data.createDoctors)
            } else {
              commit('GET_CRDOCTORSWORKPI', [])
            }
            if (data.approveDoctors.length > 0) {
              commit('GET_APDOCTORSWORKPI', data.approveDoctors)
            } else {
              commit('GET_APDOCTORSWORKPI', [])
            }
            resolve()
          })
          .catch(error => {
            commit('GET_APDOCTORSWORKPI', [])
            commit('GET_CRDOCTORSWORKPI', [])
            reject(error)
          })
      })
    },
    GetModalityCountForPI({ commit }, data) {
      // 执行单列表
      return new Promise((resolve, reject) => {
        GetModalityCountForPI(data)
          .then(response => {
            const data = response.data
            commit('GET_WATHCHOBJ', data)
            if (data.hospitals.length > 0) {
              commit('GET_HOSPWORKPI', data.hospitals)
            } else {
              commit('GET_HOSPWORKPI', [])
            }
            resolve()
          })
          .catch(error => {
            commit('GET_HOSPWORKPI', [])
            reject(error)
          })
      })
    },
    GetModalityCountByDepartId({ commit }, data) {
      // 执行单列表
      return new Promise((resolve, reject) => {
        GetModalityCountByDepartId(data)
          .then(response => {
            const data = response.data
            if (data.hospitals.length > 0) {
              var obj = {
                hospName: '总数',
                totalCount: data.totalCount,
                modalitys: data.allModalitys
              }
              data.hospitals.push(obj)
              for (var i = 0; i < data.hospitals.length; i++) {
                for (var v = 0; v < data.hospitals[i].modalitys.length; v++) {
                  data.hospitals[i][
                    data.hospitals[i].modalitys[v].modalityName
                  ] = data.hospitals[i].modalitys[v].count
                }
              }
              commit('GET_HOSPWORK', data.hospitals)
            } else {
              commit('GET_HOSPWORK', [])
            }
            if (data.allModalitys.length > 0) {
              commit('GET_DEVICESWORK', data.allModalitys)
            } else {
              commit('GET_DEVICESWORK', [])
            }
            resolve()
          })
          .catch(error => {
            commit('GET_HOSPWORK', [])
            commit('GET_DEVICESWORK', [])
            commit('GET_WATHCHOBJ', {})
            reject(error)
          })
      })
    },
    GetSelfDepartPositiveRate({ commit }, data) {
      // 获取本科室阳性率数据
      return new Promise((resolve, reject) => {
        GetSelfDepartPositiveRate(data)
          .then(response => {
            const data = response.data
            // commit('GET_SELFDEPARTPOSITIVERATE', data)
            commit('GET_SELFDEPARTPOSITIVERATEPI', data)
            if (data.list.length > 0) {
              commit('GET_SELFDEPARTPOSITIVERATE', data.list)
            } else {
              commit('GET_SELFDEPARTPOSITIVERATE', [])
            }
            resolve()
          })
          .catch(error => {
            commit('GET_SELFDEPARTPOSITIVERATE', [])
            reject(error)
          })
      })
    }
  }
}

export default statistic
